


















































import { Component, Vue, Watch } from 'vue-property-decorator';
import MelosInput from '@/components/MelosInput.vue';
import MelosButton from '@/components/MelosButton.vue';
import MelosButtonSet from '@/components/MelosButtonSet.vue';
import MelosCover from '@/components/MelosCover.vue';
import _ from 'lodash';

@Component({
  components: {
    MelosInput,
    MelosButton,
    MelosCover,
    MelosButtonSet,
  },
})
export default class UserDetails extends Vue {
  private currentPassword: string = '';
  private newPassword: string = '';
  private newPasswordConfirmation: string = '';

  private get username(): string {
    return this.$store.state.session?.username || '';
  }

  private get id(): string {
    return this.$store.state.session?.userId || '';
  }

  private get passwordChangeReady(): boolean {
    return this.currentPassword !== ''
    && this.newPassword !== ''
    && this.newPasswordConfirmation === this.newPassword;
  }

  private changePassword() {
    return this.$apiService.changePassword(this.username, this.currentPassword, this.newPassword);
  }

  private logOut() {
    this.$sessionService.clearSession();
    this.$router.push('/home/stations');
  }

}
